<div class="col-12 floatleft" id="mymaterial_topcontent">

    <div class="col-xs-10 col-md-10 col-lg-10 mymaterial_topcontentleftcontentUK">
        <h1 class="col-12 mymaterial_titeltop modified-h1">{{"myMaterial.title" | cxTranslate}}</h1>

        <div class="col-12 " id="orders_topcontentukselect">
        <select (change)="selectedSeason($event)" class="acurrent_sesson_dropdownUK" name="session" id="select_season" >
            @for(obj of seasonData?.seqirusSeasonList; track obj;let i= $index){
            <option  [value]="obj" [selected]="parameterobj?.season == obj"> {{(obj == seasonData.inSeason)?'Select Season': 'Select Season'}} {{obj.replace('-20','/')}} </option>
            }
        </select>
     </div>
    </div>
    <div class="col-xs-2 col-md-2 col-lg-2 no-dis mymaterial_topcontentleftcontentUK">
        <div class="col-xs-12 mymaterial_titeltop mymaterial_titeltopNo">
            @if(seasonData?.orderCount){
            <span >{{seasonData?.orderCount}}</span>
            }
            @if(!seasonData?.orderCount){
            <span>0</span>
            }
            {{"myMaterial.orderLabel" | cxTranslate}}</div>

    </div>
</div>